import React from "react";
import styles from "./PeopleUI.module.css";
import Avatar from "../../../components/common/Avatar";
import EmptyContact from "./EmptyContact";
import { getRoleVariant } from "./roleVariant";

const VARIANT_CLASS = {
  owner: styles.roleOwner,
  employee: styles.roleEmployee,
  contractor: styles.roleContractor,
  invited: styles.roleInvited,
  role: styles.roleRole,
};

export default function PersonCompactCard({ employee, onClick, onAddContactInfo }) {
  const variant = getRoleVariant(employee);
  const isInvited = variant === "invited";
  const isContractor = variant === "contractor";

  const accentClass = VARIANT_CLASS[variant] || styles.roleNeutral;

  const email = employee.email || "";
  const phone = employee.phone_number || employee.phone || "";
  const jobTitle = employee.job_title || "";
  const hasContact = !!(email || phone);

  const metaPrimary = email || phone;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.personCard} ${accentClass}`}
      aria-label={employee.name}
    >
      <Avatar
        name={employee.name}
        imageUrl={employee.avatar_url}
        size="sm"
        variant={isContractor ? "contractor" : "default"}
      />
      <div className={styles.personCardBody}>
        <span className={styles.personCardName}>{employee.name}</span>
        {hasContact ? (
          <span className={styles.personCardMeta}>
            {jobTitle ? `${jobTitle} · ` : ""}{metaPrimary}
          </span>
        ) : jobTitle ? (
          <span className={styles.personCardMeta}>{jobTitle}</span>
        ) : (
          <EmptyContact
            employee={employee}
            onAddContactInfo={onAddContactInfo}
            variant={isContractor ? "link" : "muted"}
          />
        )}
      </div>
      <div className={styles.personCardRight}>
        {isInvited && <span className={styles.personCardInvitedTag}>Invited</span>}
      </div>
    </button>
  );
}
